import { default as index9FYwQxFxu1Meta } from "/home/runner/work/nuxt-wp-redirects/nuxt-wp-redirects/pages/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/nuxt-wp-redirects/nuxt-wp-redirects/pages/index.vue")
  }
]